import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
function Spinner({ className, delay, size }) {
    return React.createElement(Spin, { className: className, delay: delay || 500, indicator: React.createElement(LoadingOutlined, null), size: size || 'default' });
}
export default Spinner;
